/* FTB - HOVERING A COLOUR SHOWS THAT COLOUR. Two surfaces, two parts:
   PART 1 (below) the CARD grid. PART 2 (bottom of file) the PRODUCT PAGE
   gallery. They share no code; see the banner above part 2 for why they
   nonetheless live together.

   PART 1 - colour chip hover should always change the card image.

   Broadcast already does this, but only when the theme emitted a
   .product-item__bg__inner layer whose data-variant-title matches the chip's
   data-swatch-variant-name. That layer is only emitted for variants that carry
   a featured image, so on several products (the trucker hats, the reflective
   tee and pullover) hovering a chip did nothing at all.

   This module fills the gap. When a chip has no matching layer, it resolves an
   image for that colour from the product JSON - first from the variant's own
   featured image, then by matching the colour name against the media alt text,
   which is how the archive photos are labelled - and injects a layer carrying
   the exact data-variant-title the theme is looking for. From that point the
   theme's own mouseenter and mouseleave handlers drive it, so the behaviour and
   the fade are identical to the cards that worked already.

   Delegated listeners, for the same reason as above: search results, related
   product grids and quick view all render after page load. */
(function () {
  var cache = {};           // handle -> product JSON (or null while in flight)
  var pending = {};         // handle -> array of callbacks
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';

  function norm(s) { return (s || '').replace(/\s+/g, ' ').trim().toLowerCase(); }

  function fetchProduct(handle, cb) {
    if (cache[handle] !== undefined) { cb(cache[handle]); return; }
    if (pending[handle]) { pending[handle].push(cb); return; }
    pending[handle] = [cb];
    fetch(root + 'products/' + handle + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; })
      .then(function (d) {
        cache[handle] = d || null;
        var q = pending[handle] || [];
        delete pending[handle];
        q.forEach(function (f) { try { f(cache[handle]); } catch (e) {} });
      });
  }

  function colourIndex(d) {
    var names = (d.options || []).map(function (o) {
      return norm(typeof o === 'string' ? o : o.name);
    });
    for (var i = 0; i < names.length; i++) {
      if (names[i] === 'color' || names[i] === 'colour') return i;
    }
    return names.length === 1 ? 0 : -1;
  }

  function sized(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
  }

  /* Rank an alt string for a given colour. Higher is better, 0 means no match.
     Longer sibling colour names win the string, so "White" does not steal an
     image labelled "White & Black". Front shots beat back shots, and a plain
     shot beats the simulated-reflection version. */
  function altScore(alt, colour, siblings) {
    var a = norm(alt), c = norm(colour);
    if (!c || a.indexOf(c) === -1) return 0;
    for (var i = 0; i < siblings.length; i++) {
      var s = norm(siblings[i]);
      if (s !== c && s.indexOf(c) > -1 && a.indexOf(s) > -1) return 0;
    }
    var score = 1;
    if (a.indexOf('front') > -1) score += 4;
    if (a.indexOf('simulated') === -1) score += 2;
    return score;
  }

  function resolveImage(d, colour, siblings) {
    var ci = colourIndex(d), i;
    if (ci > -1) {
      for (i = 0; i < (d.variants || []).length; i++) {
        var v = d.variants[i];
        if (norm(v.options && v.options[ci]) !== norm(colour)) continue;
        if (v.featured_image && v.featured_image.src) return sized(v.featured_image.src, 800);
      }
    }
    var media = d.media || d.images || [], best = 0, url = '';
    for (i = 0; i < media.length; i++) {
      var m = media[i];
      var src = typeof m === 'string' ? m : (m.src || (m.preview_image && m.preview_image.src));
      var alt = typeof m === 'string' ? '' : (m.alt || '');
      var sc = altScore(alt, colour, siblings);
      if (sc > best) { best = sc; url = src; }
    }
    return best ? sized(url, 800) : '';
  }

  function nativeLayer(card, name) {
    var layers = card.querySelectorAll('[data-variant-title]');
    for (var i = 0; i < layers.length; i++) {
      if (layers[i].getAttribute('data-variant-title') === name) return layers[i];
    }
    return null;
  }

  function inject(card, name, url) {
    var bg = card.querySelector('.product-item__bg');
    var model = bg && bg.querySelector(':scope > figure');
    if (!bg || !model || !url) return null;

    var layer = document.createElement('div');
    layer.className = 'product-item__bg__inner';
    layer.setAttribute('data-variant-title', name);
    layer.setAttribute('data-ftb-swap', '1');

    var fig = model.cloneNode(true);
    fig.classList.remove('lazy-image', 'lazy-image--backfill', 'is-loading');
    fig.removeAttribute('data-aos');
    var imgs = fig.querySelectorAll('img');
    Array.prototype.forEach.call(imgs, function (im) {
      im.removeAttribute('srcset');
      im.removeAttribute('sizes');
      im.removeAttribute('data-src');
      im.removeAttribute('data-srcset');
      im.setAttribute('loading', 'eager');
      im.src = url;
    });
    layer.appendChild(fig);
    bg.appendChild(layer);
    return layer;
  }

  function show(card, layer) {
    var all = card.querySelectorAll('[data-variant-title]');
    Array.prototype.forEach.call(all, function (l) { l.classList.remove('is-visible'); });
    layer.classList.add('is-visible');
  }

  function chipOf(e) {
    var t = e.target;
    if (!t || !t.closest) return null;
    var chip = t.closest('[data-swatch-button]');
    if (!chip) return null;
    if (chip.hasAttribute('data-sibling-image')) return null;   // siblings have their own layer
    if (!chip.closest('grid-swatch')) return null;
    return chip;
  }

  function handleOf(card) {
    var gs = card.querySelector('grid-swatch');
    var h = gs && gs.getAttribute('data-swatch-handle');
    if (h) return h;
    var url = card.getAttribute('data-url') || '';
    var m = url.split('?')[0].split('/products/')[1];
    return m ? m.split('/')[0] : '';
  }

  function onChip(e) {
    var chip = chipOf(e);
    if (!chip) return;
    var card = chip.closest('[data-grid-item]');
    if (!card) return;

    var name = chip.getAttribute('data-swatch-variant-name') || '';
    if (!name) return;
    if (nativeLayer(card, name)) return;            // the theme can handle this one

    var existing = null;
    var mine = card.querySelectorAll('[data-ftb-swap]');
    for (var i = 0; i < mine.length; i++) {
      if (mine[i].getAttribute('data-variant-title') === name) existing = mine[i];
    }
    if (existing) { show(card, existing); return; }

    var handle = handleOf(card);
    if (!handle) return;

    var colour = chip.getAttribute('data-tooltip') || '';
    var siblings = Array.prototype.map.call(
      card.querySelectorAll('grid-swatch [data-swatch-button]'),
      function (c) { return c.getAttribute('data-tooltip') || ''; }
    );

    fetchProduct(handle, function (d) {
      if (!d) return;
      var url = resolveImage(d, colour, siblings);
      if (!url) return;
      var layer = inject(card, name, url);
      if (!layer) return;
      // The theme's own mouseenter already fired and found nothing, so if the
      // pointer is still on this chip, reveal the layer here. Wait for the image
      // to arrive first, otherwise the card flashes empty for a frame. Every
      // later hover is handled by the theme, because the layer now exists.
      var im = layer.querySelector('img');
      var reveal = function () { if (chip.matches(':hover')) show(card, layer); };
      if (im && !im.complete) { im.addEventListener('load', reveal); im.addEventListener('error', reveal); }
      else reveal();
    });
  }

  /* Build every missing layer for a card up front, hidden, so the images are
     already in the browser cache by the time a chip is hovered. */
  function prime(card, d) {
    if (!d || card.hasAttribute('data-ftb-primed')) return;
    card.setAttribute('data-ftb-primed', '1');
    var chips = card.querySelectorAll('grid-swatch [data-swatch-button]');
    var siblings = Array.prototype.map.call(chips, function (c) {
      return c.getAttribute('data-tooltip') || '';
    });
    Array.prototype.forEach.call(chips, function (chip) {
      var name = chip.getAttribute('data-swatch-variant-name') || '';
      if (!name || nativeLayer(card, name)) return;
      var url = resolveImage(d, chip.getAttribute('data-tooltip') || '', siblings);
      if (url) inject(card, name, url);
    });
  }

  /* Warm the product JSON as soon as the card is hovered, so the swap is
     instant by the time the pointer reaches the chips. */
  function onCard(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var card = t.closest('[data-grid-item]');
    if (!card || !card.querySelector('grid-swatch [data-swatch-button]')) return;
    if (card.hasAttribute('data-ftb-primed')) return;
    var handle = handleOf(card);
    if (!handle) return;
    fetchProduct(handle, function (d) { prime(card, d); });
  }

  document.addEventListener('mouseover', onChip, true);
  document.addEventListener('mouseover', onCard, true);
  document.addEventListener('focusin', onChip, true);
})();

/* ============================================================================
   PART 2 - THE PRODUCT PAGE. Added 2026-08-28 on his request: "on hover I'd
   like the product image associated with that color to show up on the left."

   Everything above is the CARD grid and shares nothing with this: different
   DOM, different mechanism, different data source. They live in one file
   because they are one feature to a reader ("hovering a colour shows me that
   colour"), and because keeping it here means layout/theme.liquid does not
   have to change at all - this file is already loaded site wide.

   [!] IT CLICKS THE THEME'S OWN THUMBNAIL INSTEAD OF MOVING THE GALLERY.
   Measured before it was written: a thumb click swaps the slide, sets
   media--active, updates product-images[data-active-media] and moves
   aria-current, WITHOUT navigating, without changing the checked variant, the
   price or the URL. Reimplementing any of that would drift from the theme.
   [!] DO NOT DO THIS BY CHECKING THE RADIO. That swaps the image, but it also
   changes the selected variant, the price, the buy button and the URL. Hover
   must not mutate the selection.

   [!] SIZE PILLS CARRY data-ftb-media TOO, because it rides on the shared
   input_dataset in product-variant-options.liquid. Every size in a colour
   resolves to the SAME media, so hovering sizes would be meaningless flicker.
   Two guards: only `.swatch__button` is bound, and any option group whose
   values all share one media id is skipped. The second guard is the one that
   still holds if the colour picker is ever switched to the button style.

   Timings: SWAP_DELAY stops a fast sweep across five swatches from firing five
   swaps; RESTORE_GRACE stops the gallery snapping back in the gap between
   leaving one swatch and entering its neighbour.
   ============================================================================ */
(function () {
  if (!window.matchMedia || !window.matchMedia('(hover: hover) and (pointer: fine)').matches) return;

  var SWAP_DELAY = 70;
  var RESTORE_GRACE = 140;

  function setup(gallery) {
    if (gallery.hasAttribute('data-ftb-pdp-hover')) return;
    var scope = gallery.closest('product-info');
    if (!scope) return;

    var swatches = [].slice.call(scope.querySelectorAll('.swatch__button'))
      .filter(function (b) {
        var i = b.querySelector('input[data-ftb-media]');
        return !!i;
      });
    if (swatches.length < 2) return;

    /* Guard 2: a group whose values all point at one image has nothing to show. */
    var ids = swatches.map(function (b) {
      return b.querySelector('input[data-ftb-media]').getAttribute('data-ftb-media');
    });
    var distinct = ids.filter(function (v, i) { return ids.indexOf(v) === i; });
    if (distinct.length < 2) return;

    var thumbs = [].slice.call(scope.querySelectorAll('.product__thumb__link'));
    if (!thumbs.length) return;

    gallery.setAttribute('data-ftb-pdp-hover', '1');

    function thumbFor(id) {
      for (var i = 0; i < thumbs.length; i++) {
        var m = thumbs[i].getAttribute('data-media-id');
        if (m && m.slice(-(id.length + 1)) === '-' + id) return thumbs[i];
      }
      return null;
    }
    function activeId() {
      var s = gallery.querySelector('.product__slide.media--active');
      return s ? s.getAttribute('data-image-id') : null;
    }
    function show(id) {
      if (!id || activeId() === id) return;
      var t = thumbFor(id);
      if (!t) return;
      /* Tell part 3 this is a preview, not a selection, so the thumbnail strip
         does not scroll itself under a sweep across the swatches. Cleared on a
         macrotask, after part 3's MutationObserver microtask has run. */
      var de = document.documentElement;
      de.setAttribute('data-ftb-gallery-preview', '1');
      t.click();
      setTimeout(function () { de.removeAttribute('data-ftb-gallery-preview'); }, 0);
    }

    var baseline = null, hovering = false, tIn = null, tOut = null;
    function reset() { clearTimeout(tIn); clearTimeout(tOut); hovering = false; baseline = null; }

    swatches.forEach(function (btn) {
      var id = btn.querySelector('input[data-ftb-media]').getAttribute('data-ftb-media');
      btn.addEventListener('pointerenter', function () {
        clearTimeout(tOut); clearTimeout(tIn);
        /* Capture on the FIRST swatch entered, not on every one, or the
           "restore" target becomes the previous swatch's image. */
        if (!hovering) { baseline = activeId(); hovering = true; }
        tIn = setTimeout(function () { show(id); }, SWAP_DELAY);
      });
      btn.addEventListener('pointerleave', function () {
        clearTimeout(tIn);
        tOut = setTimeout(function () {
          if (hovering && baseline) show(baseline);
          hovering = false; baseline = null;
        }, RESTORE_GRACE);
      });
    });

    /* A real selection hands the gallery back to the theme; drop our baseline
       so we never restore over what the shopper actually chose. */
    scope.querySelectorAll('.swatch__button input').forEach(function (i) {
      i.addEventListener('change', reset);
    });
  }

  function scan() {
    document.querySelectorAll('product-images').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  /* The quick-view drawer and variant swaps re-render this markup. */
  document.addEventListener('shopify:section:load', scan);
  var rescan = null;
  new MutationObserver(function () {
    clearTimeout(rescan);
    rescan = setTimeout(scan, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();

/* ============================================================================
   PART 3 - THE GALLERY THUMBNAIL STRIP. Added 2026-08-28 on his call, three
   jobs in one module because they are three faces of one component.

   WHY IT IS HERE AND NOT IN A NEW FILE: part 2 already drives this strip (it
   swaps the gallery by clicking a thumbnail), and the two must not fight over
   the gallery while a preview is running. Sharing a file makes that contract
   visible instead of implicit, and this file is already loaded site wide, so
   layout/theme.liquid still does not have to change.

   JOB 1 - AN AFFORDANCE. product.css deletes the scrollbar and, below 750,
   replaces it with scroll snapping. Desktop got the deletion and no
   replacement: at the 1387 review width the holder is 636 against an 850
   scrollWidth, so 3 of 10 thumbnails are hidden with nothing on screen saying
   so, and the Bronx Collegiate T-Shirt hides 33 of 40. The arrows are built
   from the theme's own `.slider__button`, so an empty BUTTON with those two
   classes is the whole widget: the circle, the icon and the fill-wipe are all
   pseudo-elements in theme.css, and `:disabled` hides the end you are at.

   JOB 2 - THE STRIP NOW FOLLOWS THE GALLERY. It never did. Twelve clicks of
   the main next arrow left scrollLeft at 0 and the active thumbnail 34px past
   the right edge, so the marker saying which photo you were on was off screen.

   JOB 3 - HOVER A THUMBNAIL, SEE IT BIG. His request: "when I hover over an
   image in the slider, I'd like the main image to change too. Similar to when
   I hover over an alt color." Same mechanism and the same two timings as part
   2, deliberately, so the two previews feel like one behaviour.

   [!] DELEGATED, UNLIKE PART 2, BECAUSE THE THEME RE-RENDERS THIS STRIP on a
   variant change and part 2's captured node list is a known weakness. Listen
   on the holder with pointerover/pointerout, which bubble, and guard the
   pointerout with relatedTarget so moving onto the IMG inside a thumbnail does
   not read as leaving it.

   [!] `follow()` MUST NOT RUN DURING A PREVIEW. A preview moves is-active, and
   a half-visible thumbnail that scrolls itself into view under the cursor
   would move the strip out from under the pointer. Hence the shared
   `data-ftb-gallery-preview` flag on the documentElement, which part 2 sets
   too. Cleared on a macrotask, so the MutationObserver microtask sees it.

   [!] THE SYNTHETIC CLICK MUST NOT LOOK LIKE THE SHOPPER'S CLICK. A real click
   on a thumbnail is a selection and has to drop the restore baseline; our own
   click must not. Hence `synthetic`, which is safe as a plain flag only
   because .click() dispatches synchronously.
   ============================================================================ */
(function () {
  var MIN_WIDTH = 750;
  var SWAP_DELAY = 70;
  var RESTORE_GRACE = 140;
  var GUTTER = 10;
  var fine = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);

  function preview(on) {
    var de = document.documentElement;
    if (on) de.setAttribute('data-ftb-gallery-preview', '1');
    else de.removeAttribute('data-ftb-gallery-preview');
  }

  /* scrollBy's `behavior: "smooth"` is an explicit request and ignores the OS
     setting; only the CSS scroll-behavior property honours it on its own. Ask. */
  function ease() {
    return (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) ? 'auto' : 'smooth';
  }

  function arrow(dir) {
    var b = document.createElement('button');
    b.type = 'button';
    b.className = 'slider__button slider__button--' + dir;
    b.setAttribute('aria-label', dir === 'prev' ? 'Show previous thumbnails' : 'Show more thumbnails');
    return b;
  }

  function setup(thumbs) {
    if (thumbs.hasAttribute('data-ftb-thumbs')) return;
    var holder = thumbs.querySelector('.product__thumbs__holder');
    if (!holder) return;
    /* Broadcast also ships a thumbnails-left layout where this holder is a
       sticky 85px COLUMN. None of the below applies to it, and an unguarded
       `position: relative` in the stylesheet would have killed the sticky. */
    if (getComputedStyle(holder).flexDirection === 'column') return;

    thumbs.setAttribute('data-ftb-thumbs', '1');
    thumbs.classList.add('ftb-thumbs-scroller');

    var prev = arrow('prev'), next = arrow('next');
    thumbs.appendChild(prev);
    thumbs.appendChild(next);

    /* One screenful less one thumbnail, so the thumb you were looking at stays
       on screen as an anchor rather than the strip jumping clean past it. */
    function page() { return Math.max(85, holder.clientWidth - 85); }
    prev.addEventListener('click', function () { holder.scrollBy({ left: -page(), behavior: ease() }); });
    next.addEventListener('click', function () { holder.scrollBy({ left: page(), behavior: ease() }); });

    function sync() {
      var max = holder.scrollWidth - holder.clientWidth;
      var live = max > 1 && window.innerWidth >= MIN_WIDTH;
      var atStart = holder.scrollLeft <= 1;
      var atEnd = holder.scrollLeft >= max - 1;
      thumbs.classList.toggle('ftb-scroll-prev', live && !atStart);
      thumbs.classList.toggle('ftb-scroll-next', live && !atEnd);
      prev.disabled = !live || atStart;
      next.disabled = !live || atEnd;
    }

    function follow() {
      if (window.innerWidth < MIN_WIDTH) return;
      if (document.documentElement.hasAttribute('data-ftb-gallery-preview')) return;
      var a = holder.querySelector('.product__thumb.is-active');
      if (!a) return;
      var ar = a.getBoundingClientRect(), hr = holder.getBoundingClientRect();
      var d = 0;
      if (ar.left < hr.left) d = ar.left - hr.left - GUTTER;
      else if (ar.right > hr.right) d = ar.right - hr.right + GUTTER;
      if (!d) return;
      holder.scrollBy({ left: d, behavior: ease() });
    }

    holder.addEventListener('scroll', sync);
    window.addEventListener('resize', sync);
    window.addEventListener('load', sync);
    new MutationObserver(function () { sync(); follow(); })
      .observe(holder, { attributes: true, attributeFilter: ['class'], subtree: true });
    sync();

    if (!fine) return;
    if (holder.querySelectorAll('.product__thumb__link').length < 2) return;

    function activeLink() {
      return holder.querySelector('.product__thumb.is-active .product__thumb__link');
    }

    var baseline = null, hovering = false, current = null, synthetic = false;
    var tIn = null, tOut = null;

    function go(link) {
      if (!link || link === activeLink()) return;
      synthetic = true;
      preview(true);
      link.click();
      synthetic = false;
      setTimeout(function () { preview(false); }, 0);
    }

    holder.addEventListener('pointerover', function (e) {
      if (!e.target || !e.target.closest) return;
      var link = e.target.closest('.product__thumb__link');
      if (!link || link === current) return;
      current = link;
      clearTimeout(tOut);
      clearTimeout(tIn);
      /* Capture on the FIRST thumbnail entered, not on every one, or the
         restore target becomes the previous thumbnail. Same reasoning, and the
         same bug, as part 2. */
      if (!hovering) { baseline = activeLink(); hovering = true; }
      tIn = setTimeout(function () { go(link); }, SWAP_DELAY);
    });

    holder.addEventListener('pointerout', function (e) {
      if (!e.target || !e.target.closest) return;
      var link = e.target.closest('.product__thumb__link');
      if (!link) return;
      if (e.relatedTarget && link.contains(e.relatedTarget)) return;
      if (current === link) current = null;
      clearTimeout(tIn);
      tOut = setTimeout(function () {
        if (hovering && baseline) go(baseline);
        hovering = false;
        baseline = null;
      }, RESTORE_GRACE);
    });

    /* A real click is a selection. Hand the gallery back and never restore
       over what the shopper actually chose. */
    holder.addEventListener('click', function (e) {
      if (synthetic) return;
      if (!e.target || !e.target.closest) return;
      if (!e.target.closest('.product__thumb__link')) return;
      clearTimeout(tIn);
      clearTimeout(tOut);
      hovering = false;
      baseline = null;
    });
  }

  function scan() {
    document.querySelectorAll('.product__thumbs').forEach(setup);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', scan);
  } else {
    scan();
  }
  document.addEventListener('shopify:section:load', scan);
  var rescan = null;
  new MutationObserver(function () {
    clearTimeout(rescan);
    rescan = setTimeout(scan, 200);
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
